import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SeoRequest from '../../../RunPay/Admin/IServices/Models/Seo/SeoRequest';
import SaveSeoRequest from '../../../RunPay/Admin/IServices/Models/Seo/SaveSeoRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import SeoItemResponse from '../../../RunPay/Admin/IServices/Models/Seo/SeoItemResponse';
import BaseResponse from '../../../Common/ResponseModels/BaseResponse';

export default class SeoService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModel<PaginationResponse<SeoItemResponse>>>();
	SaveEvent = new Events<WsResponseModel<number>>();
	DeleteEvent = new Events<WsResponseModel<BaseResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('SeoService', 'GetList', (res: WsResponseModel<PaginationResponse<SeoItemResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('SeoService', 'Save', (res: WsResponseModel<number>) => {
			self.SaveEvent.trigger(res);
		});
		webApiService.on('SeoService', 'Delete', (res: WsResponseModel<BaseResponse>) => {
			self.DeleteEvent.trigger(res);
		});
	}
	GetList(request: SeoRequest = null) { 	
        this.webApiService.send('SeoService', 'GetList' , request);
    }
	Save(request: SaveSeoRequest = null) { 	
        this.webApiService.send('SeoService', 'Save' , request);
    }
	Delete(id: number = 0) { 	
        this.webApiService.send('SeoService', 'Delete' , id);
    }
	 // async methods
	async getListAsync(request: SeoRequest = null): Promise<PaginationResponse<SeoItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async saveAsync(request: SaveSeoRequest = null): Promise<number> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/SeoService.ts